import { Link } from 'react-router-dom';
import { CONTACTS } from '../config/contacts';
import { useLanguage } from '../i18n/LanguageContext';

export function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div className="footer-brand">
          <img src="/brand/queen-logo.png" alt="Queen English Academy" width="877" height="877" />
          <p>{t.footer.motto}</p>
        </div>
        <div className="footer-contact" id="contact">
          <span className="contact-mark" aria-hidden="true">◆</span>
          <p>{t.footer.gate}</p>
          <div className="footer-contact-links">
            <a href={CONTACTS.phoneHref}>{CONTACTS.phoneDisplay}</a>
            <a href={CONTACTS.telegramUrl} target="_blank" rel="noreferrer">Telegram · {CONTACTS.telegramHandle}</a>
          </div>
          <Link className="footer-test-link" to="/test">{t.nav.test} <span aria-hidden="true">→</span></Link>
        </div>
      </div>
      <div className="shell footer-bottom">
        <span>© {new Date().getFullYear()} Queen English Academy</span>
        <span>{t.footer.rights}</span>
      </div>
    </footer>
  );
}
